import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

import { API } from '@/config/api';

export const useCommesse = () => {
  const [commesse, setCommesse] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchCommesse = useCallback(async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API}/commesse`);
      if (Array.isArray(response.data)) {
        setCommesse(response.data);
      } else {
        console.warn('API returned non-array for commesse:', response.data);
        setCommesse([]);
      }
      setError(null);
    } catch (err) {
      console.error('Error fetching commesse:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCommesse();
  }, [fetchCommesse]);

  const createCommessa = async (commessaData) => {
    try {
      const response = await axios.post(`${API}/commesse`, commessaData);
      await fetchCommesse();
      return { success: true, commessa: response.data };
    } catch (err) {
      return { success: false, error: err.response?.data?.detail || err.message };
    }
  };

  return { commesse, loading, error, refetch: fetchCommesse, createCommessa };
};
